const isRequired = {
  errorMessage: 'ERROR_IS_REQUIRED',
  rule: (value: any) => !!value,
};

export default isRequired;
